export const ADMIN = 'ADMIN';
export const DEALER = 'DEALER';
export const WERKNEMER = 'WERKNEMER';
export const WERKGEVER = 'WERKGEVER';
